import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  InputGroup,
  ListGroup,
  Modal,
  Offcanvas,
  Spinner
} from 'react-bootstrap';
import api from 'util/api';
import logger from 'util/logger';
import _ from 'lodash';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import {
  actionAddIdentification,
  actionAddWitnessIdentification,
  actionLogSigningAction,
  actionMapSignerToAllDocs,
  actionSetSignerIdType,
  actionSetSignerName,
  actionSetWitnessLocation,
  actionSetWitnessSignature
} from 'stores/signing';
import enums from 'util/enums';
import idGenerator from 'util/idGenerator';
import {
  faArrowRight,
  faExclamationTriangle,
  faStar
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import draftEntryUiHelper from 'helpers/draft-entry-ui-helper';
import segmentHelper from 'helpers/segment-helper';
import IconAlert from 'components/common/IconAlert';
import filters from 'util/filters';
import { useAsyncDebounce } from 'react-table';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const LoadColleague = ({
  showColleagueModal,
  setShowColleagueModal,
  setSignerData,
  signerData,
  setShowIdentityForm,
  showIdentityForm,
  setCollapsed,
  identityItem,
  setIsColleagues,
  setIsColleaguesWitness,
  isManualIDSelected,
  setIsManualIDSelected,
  selectedColleague,
  setSelectedColleague,
  resetSignerState,
  isDocumentWitness,
  setIsDocumentWitness,
  setAddressValue,
  isFrom,
  signerByMark,
  setSignerByMark,
  isSignerByMarkIndex,
  setIsSignerByMarkIndex,
  openWitnessIdentityForm,
  openDocumentWithness,
  setIsManualIDSelectedForMarkWitness
}) => {
  const [loading, setLoading] = useState(false);
  const [masterSignerList, setMasterSignerList] = useState([]);
  const [openOptions, setOpenOptions] = useState(false);
  const [openSavedIDOptions, setOpenSavedIDOptions] = useState(false);
  const [openLegalNotice, setOpenLegalNotice] = useState(false);
  const [openPesonallyNotice, setOpenPesonallyNotice] = useState(false);
  const [selectedID, setSelectedID] = useState({});
  const [currentState, setCurrentState] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [indexStart, setIndexStart] = useState(0); // Track the starting index for API calls
  const [hasMoreData, setHasMoreData] = useState(false);
  const [sortBy, setSortBy] = useState('Created');
  const [isAsc, setIsAsc] = useState(false);
  const dispatch = useDispatch();

  const { signers, identifications, witnesses } = useSelector(
    state => state.signing
  );

  const loadMasterSiners = (
    start,
    searchValue,
    sortBy = 'Created',
    sortOrder = false
  ) => {
    if (loading) return;
    setLoading(true);
    setHasMoreData(false);

    const trimmed = (searchValue || '').trim();
    const effectiveSortKey = sortBy === 'IsFavorite' ? 'FirstName' : sortBy;
    const obj = {
      MaxResults: 25,
      Skip: start ? indexStart : 0,
      OrderBy: effectiveSortKey,
      OrderDirection: sortOrder ? 'asc' : 'desc',
      // The client picker only renders Identification metadata (IdType, IdNumber,
      // names, addresses, dates) for badges and selection — it never displays blob
      // bytes (photos/ID scans/audit logs) or a client's signing history.
      // IncludeSubordinates stays true so Identifications are populated; IncludeData
      // is false to avoid per-row blob byte hydration and the per-signing read loop
      // on the backend, which made this list very slow for frequently-used clients.
      IncludeData: false,
      IncludeSubordinates: true,
      // Full-text search across client fields (matches the Client List page), rather
      // than a first-name-only filter.
      ...(trimmed.length > 0 && { Text: trimmed }),
      Filters: {
        ...(sortBy === 'IsFavorite' && { IsFavorite: 1 }),
        IsDeleted: 0
      }
    };

    api
      .Enumeration(enums.ENUMERATION_TYPES.SIGNER, obj)
      .then(res => {
        const objects = res?.Objects || [];
        setLoading(false);
        if (objects.length === 0) {
          setHasMoreData(true); // no data available
          if (searchKeyword) setMasterSignerList([]);
        }
        setIndexStart(prev => prev + 25);
        if (start) {
          setMasterSignerList(prev => [...prev, ...objects]); // Append
        } else {
          setMasterSignerList(objects); // Fresh load
        }
        setCurrentState('load_colleague');
      })
      .catch(err => {
        setLoading(false);
        setHasMoreData(false); // Better to assume failure means "stop loading more"
        logger.log('error loading Master client ', err);
      });
  };

  useEffect(() => {
    setMasterSignerList([]);
    if (showColleagueModal) {
      loadMasterSiners(false, searchKeyword, sortBy, isAsc);
    }
  }, [showColleagueModal]);
  const resetLoadCollegues = () => {
    setIndexStart(0);
    setSearchKeyword('');
    setLoading(false);
    setHasMoreData(true);
    setOpenOptions(false);
    setOpenSavedIDOptions(false);
    setOpenLegalNotice(false);
    setOpenPesonallyNotice(false);
    setSelectedID({});
    setCurrentState('load_colleague');
    setMasterSignerList([]);
    setSortBy('Created');
    setIsAsc(false);

    //setp2 clear state
    setIsColleaguesWitness && setIsColleaguesWitness(false);
    setIsManualIDSelected(false);
    setSelectedColleague({});
    setCollapsed && setCollapsed(false);
    setIsColleagues && setIsColleagues(false);
    setShowColleagueModal(false);
    setIsDocumentWitness(false);
  };
  useEffect(() => {
    if (!showIdentityForm) {
      // cloase Load collegues model
      setLoading(false);
      setHasMoreData(true);
      setOpenOptions(false);
      setOpenSavedIDOptions(false);
      setOpenLegalNotice(false);
      setOpenPesonallyNotice(false);
      setSelectedID({});
      setCurrentState('load_colleague');
      setMasterSignerList([]);
    }
  }, [showIdentityForm]);

  const handleSelectColleague = item => {
    // Check if the master client is already used as a Document Witness or Signer
    const existing = signers.find(i => i.GUID === item.GUID);
    if (existing) {
      if (existing.isDocumentWitness) {
        toast.warning(
          `This master client is already used as a Document Witness and cannot be linked again.`,
          {
            theme: 'colored',
            position: 'bottom-center',
            icon: faExclamationTriangle
          }
        );
      } else {
        toast.warning(
          `This master client is already used as a Signer and cannot be linked again.`,
          {
            theme: 'colored',
            position: 'bottom-center',
            icon: faExclamationTriangle
          }
        );
      }
      return false;
    }
    setOpenOptions(!openOptions);
    setSelectedColleague({
      ...item,
      isDocumentWitness: isDocumentWitness
    });
    setCurrentState('load_options');
    return true;
  };
  const saveToManualIdToMasterSigner = identityItem => {
    const reqIdentity = [
      {
        Prefix: identityItem?.prefix,
        FirstName: identityItem?.id_first_name,
        MiddleName: identityItem?.id_middle_name,
        LastName: identityItem?.id_last_name,
        Suffix: identityItem?.id_suffix,
        Address1: identityItem?.id_address_1,
        Address2: identityItem?.id_address_2,
        City: identityItem?.id_city,
        State: identityItem?.id_state,
        PostalCode: identityItem?.id_postal_code,
        IdType: identityItem?.id_type,
        IdNumber: identityItem?.id_number,
        IdIssued: identityItem?.id_issued_date
          ? moment(identityItem?.id_issued_date).utc().toISOString()
          : null,
        IdExpiration: identityItem?.id_expiration_date
          ? moment(identityItem?.id_expiration_date).utc().toISOString()
          : null,
        DateOfBirth: identityItem?.date_of_birth
          ? moment(identityItem?.date_of_birth).utc().toISOString()
          : null,
        AdditionalData: identityItem?.notes,
        IdTypeOther: identityItem?.id_type_other,
        GUID: identityItem.existingColleagues || ''
      }
    ];
    console.log('chk selectedColleague', selectedColleague);
    const reqData = {
      ...selectedColleague,
      IsFavorite: selectedColleague.IsFavorite,
      Identifications: reqIdentity
    };
    console.log('chk reqData', reqData);
    if (identityItem.IsFavorite) {
      api.masterSigner.update(selectedColleague.GUID, reqData).then(() => {
        segmentHelper.track(segmentHelper.events.MASTER_CLIENT_UPDATE);
        resetSignerState();
      });
    }
  };
  useEffect(() => {
    // when select manual enter id
    if (identityItem && identityItem?.signer_id && isManualIDSelected) {
      // when select manual enter id
      if (identityItem.IsFavorite) {
        saveToManualIdToMasterSigner(identityItem);
      }
      const obj = {};
      obj.GUID = selectedColleague.GUID;
      obj.signer_first_name = selectedColleague.FirstName;
      obj.signer_id = signerData.signer_id;
      obj.signer_last_name = selectedColleague.LastName;
      obj.signer_middle_name = selectedColleague.MiddleName;
      obj.signer_prefix = selectedColleague.Prefix;
      obj.signer_suffix = selectedColleague.Suffix;
      setOpenLegalNotice(false); //close model
      setShowColleagueModal(false); // close colleague
      setCurrentState('load_colleague');

      //save on redux
      //set signer identification
      obj.signerIdentifications = [];
      obj.signerIdentifications.signer_id = obj.signer_id;
      const identificationData = {
        identification: { ...identityItem, signer_id: obj.signer_id },
        signer_id: obj.signer_id
      };
      obj.signerIdentifications = [identificationData];
      obj.Identifications = identificationData;
      obj.isDocumentWitness = isDocumentWitness;
      obj.identificationFlow = isDocumentWitness
        ? enums.UI_FLOW_TYPE.WITNESS_ONE
        : enums.UI_FLOW_TYPE.SIGNER;
      obj.sorted_witness_ids = [idGenerator.getWitnessId()];
      logAllChanges(obj); // add audit log for manual enter id
      setSignerData(obj);

      setTimeout(() => {
        return dispatch(
          actionSetSignerIdType({
            signer_id: obj.signer_id,
            identificationFlow: isDocumentWitness
              ? enums.UI_FLOW_TYPE.WITNESS_ONE
              : enums.UI_FLOW_TYPE.SIGNER
          })
        ).then(() => {
          setTimeout(() => {
            dispatch(
              actionSetSignerName({
                signer: {
                  signer_id: obj.signer_id,
                  GUID: selectedColleague.GUID,
                  signer_guid: selectedColleague.GUID,
                  signer_first_name: selectedColleague.FirstName,
                  signer_last_name: selectedColleague.LastName,
                  signer_middle_name: selectedColleague.MiddleName,
                  signer_prefix: selectedColleague.Prefix,
                  signer_suffix: selectedColleague.Suffix,
                  first_name: selectedColleague.FirstName,
                  last_name: selectedColleague.LastName,
                  middle_name: selectedColleague.MiddleName,
                  prefix: selectedColleague.Prefix,
                  suffix: selectedColleague.Suffix,
                  isDocumentWitness: isDocumentWitness
                }
              })
            ).then(() => {
              setTimeout(() => {
                // return saveIdentificationUIResults();
                if (isDocumentWitness) {
                  dispatch(
                    actionAddWitnessIdentification({
                      signer_id: obj.signer_id,
                      witness_id: obj.sorted_witness_ids[0],
                      witness_name: {
                        first_name: obj.signer_first_name,
                        middle_name: obj.signer_middle_name,
                        last_name: obj.signer_last_name,
                        suffix: obj.signer_suffix,
                        prefix: obj.signer_prefix
                      },
                      identification: {
                        ...identityItem,
                        witness_id: obj.sorted_witness_ids[0]
                      }
                    })
                  );
                } else {
                  dispatch(actionAddIdentification(identityItem));
                }
                dispatch(
                  actionMapSignerToAllDocs({ signer_id: obj.signer_id })
                );
              }, 200);
            });
          }, 100);
        });
      }, 100);
    }
  }, [identityItem]);

  const saveWitnessNameLocationResults = data => {
    let { witnessNameLocationResults } = data;

    _.each(witnessNameLocationResults, wResult => {
      if (wResult.witness_id) {
        dispatch(
          actionSetWitnessLocation({
            signer_id: signerData.signer_id,
            witness_id: wResult.witness_id,
            location: wResult.location
          })
        );
      }
    });
  };

  const saveWitnessSignatureResults = () => {
    let { witnessSignatureResults } = signerData;

    _.each(witnessSignatureResults, wResult => {
      logger.log('saving witness signature', wResult);
      if (wResult.witness_id) {
        dispatch(
          actionSetWitnessSignature({
            signer_id: signerData.signer_id,
            witness_id: wResult.witness_id,
            signature: wResult.signature,
            witness_name: {
              first_name: signerData.signer_first_name,
              middle_name: signerData.signer_middle_name,
              last_name: signerData.signer_last_name,
              suffix: signerData.signer_suffix,
              prefix: signerData.signer_prefix
            }
          })
        );
      }
    });
  };
  const handleAcknowledge = () => {
    setCurrentState('load_colleague');
    // setSignerData()
    const obj = { ...selectedColleague };
    //set signer data
    obj.GUID = selectedColleague.GUID;
    obj.signer_first_name = selectedColleague.FirstName;
    obj.signer_id = signerData.signer_id;
    obj.signer_last_name = selectedColleague.LastName;
    obj.signer_middle_name = selectedColleague.MiddleName;
    obj.signer_prefix = selectedColleague.Prefix;
    obj.signer_suffix = selectedColleague.Suffix;
    //set signer identification
    obj.signerIdentifications = [];
    obj.signerIdentifications.signer_id = obj.signer_id;
    obj.witnessChoice = isDocumentWitness
      ? enums.UI_FLOW_TYPE.WITNESS_ONE
      : enums.UI_FLOW_TYPE.SIGNER;
    const identification = obj?.Identifications?.map(identification => {
      identification.id_first_name = identification.FirstName;
      identification.id_last_name = identification.LastName;
      identification.id_middle_name = identification.MiddleName;
      identification.sufix = identification.Suffix;
      identification.prefix = identification.Prefix;
      identification.id_type = identification.IdType;
      identification.id_address_1 = identification.Address1;
      identification.id_address_2 = identification.Address2;
      identification.id_city = identification.City;
      identification.id_state = identification.State;
      identification.id_postal_code = identification.PostalCode;
      identification.id_type = identification.IdType;
      identification.id_number = identification.IdNumber;
      identification.id_issued_date = identification.IdIssued;
      identification.id_expiration_date = identification.IdExpiration;
      identification.date_of_birth = identification.DateOfBirth;
      identification.notes = identification.AdditionalData;
      identification.id_type_other = identification.IdTypeOther;
      obj.signerIdentifications.push({
        identification: identification,
        signer_id: obj.signer_id
      });
      return { identification: identification, signer_id: obj.signer_id };
    });
    obj.signerIdentifications.identification = identification;
    obj.sorted_witness_ids = [idGenerator.getWitnessId()];
    obj.witnessNameLocationResults =
      [
        {
          witness_id: obj.sorted_witness_ids[0],
          location: {
            address_1: obj.Address1,
            address_2: obj.Address2,
            city: obj.City,
            state: obj.State,
            postal_code: obj.PostalCode
          }
        }
      ] || [];
    setSignerData({ ...obj, isDocumentWitness: isDocumentWitness });
    setOpenLegalNotice(false); //close model
    setShowColleagueModal(false); // close colleague
    setCollapsed && setCollapsed(false); // close colleague

    // set identification on redux
    setTimeout(() => {
      return dispatch(
        actionSetSignerIdType({
          signer_id: obj.signer_id,
          identificationFlow: isDocumentWitness
            ? enums.UI_FLOW_TYPE.WITNESS_ONE
            : enums.UI_FLOW_TYPE.SIGNER
        })
      ).then(() => {
        setTimeout(() => {
          dispatch(
            actionSetSignerName({
              signer: {
                signer_id: obj.signer_id,
                GUID: selectedColleague.GUID,
                signer_guid: selectedColleague.GUID,
                signer_first_name: selectedColleague.FirstName,
                signer_last_name: selectedColleague.LastName,
                signer_middle_name: selectedColleague.MiddleName,
                signer_prefix: selectedColleague.Prefix,
                signer_suffix: selectedColleague.Suffix,
                first_name: selectedColleague.FirstName,
                last_name: selectedColleague.LastName,
                middle_name: selectedColleague.MiddleName,
                prefix: selectedColleague.Prefix,
                suffix: selectedColleague.Suffix,
                isDocumentWitness: isDocumentWitness
              }
            })
          ).then(() => {
            setTimeout(() => {
              // return saveIdentificationUIResults();
              if (isDocumentWitness) {
                setAddressValue({
                  address_1: obj.Address1,
                  address_2: obj.Address2,
                  city: obj.City,
                  state: obj.State,
                  zip: obj.PostalCode
                });
                dispatch(
                  actionAddWitnessIdentification({
                    signer_id: obj.signer_id,
                    witness_id: obj.sorted_witness_ids[0],
                    witness_name: {
                      first_name: obj.signer_first_name,
                      middle_name: obj.signer_middle_name,
                      last_name: obj.signer_last_name,
                      suffix: obj.signer_suffix,
                      prefix: obj.signer_prefix
                    },
                    identification: {
                      signer_id: signerData.signer_id,
                      identification_id: selectedID.identification_id
                        ? selectedID.identification_id
                        : selectedID.GUID,
                      id_first_name: selectedID.FirstName,
                      id_middle_name: selectedID.MiddleName,
                      id_last_name: selectedID.LastName,
                      prefix: selectedID.Prefix,
                      suffix: selectedID.Suffix,
                      id_type: selectedID.IdType,
                      id_type_other: selectedID.IdTypeOther,
                      id_number: selectedID.IdNumber,
                      id_issued_date: selectedID.IdIssued,
                      id_expiration_date: selectedID.IdExpiration,
                      date_of_birth: selectedID.DateOfBirth,
                      // id_issuing_state: selectedID.,
                      id_address_1: selectedID.Address1,
                      id_address_2: selectedID.Address2,
                      id_city: selectedID.City,
                      id_state: selectedID.State,
                      id_postal_code: selectedID.PostalCode,
                      notes: selectedID.AdditionalData,
                      scan_vendor: selectedID.scan_vendor,
                      scan_data: selectedID.scan_data,
                      isDocumentWitness: isDocumentWitness
                    }
                  })
                );
                saveWitnessNameLocationResults(obj);
                saveWitnessSignatureResults();
              } else {
                dispatch(
                  actionAddIdentification({
                    signer_id: signerData.signer_id,
                    identification_id: selectedID.identification_id
                      ? selectedID.identification_id
                      : selectedID.GUID,
                    id_first_name: selectedID.FirstName,
                    id_middle_name: selectedID.MiddleName,
                    id_last_name: selectedID.LastName,
                    prefix: selectedID.Prefix,
                    suffix: selectedID.Suffix,
                    id_type: selectedID.IdType,
                    id_type_other: selectedID.IdTypeOther,
                    id_number: selectedID.IdNumber,
                    id_issued_date: selectedID.IdIssued,
                    id_expiration_date: selectedID.IdExpiration,
                    date_of_birth: selectedID.DateOfBirth,
                    // id_issuing_state: selectedID.,
                    id_address_1: selectedID.Address1,
                    id_address_2: selectedID.Address2,
                    id_city: selectedID.City,
                    id_state: selectedID.State,
                    id_postal_code: selectedID.PostalCode,
                    notes: selectedID.AdditionalData,
                    scan_vendor: selectedID.scan_vendor,
                    scan_data: selectedID.scan_data,
                    isDocumentWitness: isDocumentWitness
                  })
                );
              }

              dispatch(
                actionMapSignerToAllDocs({ signer_id: signerData.signer_id })
              );
              logAllChanges({
                signer_id: obj.signer_id,
                GUID: selectedColleague.GUID,
                signer_first_name: selectedColleague.FirstName,
                signer_last_name: selectedColleague.LastName,
                signer_middle_name: selectedColleague.MiddleName,
                signer_prefix: selectedColleague.Prefix,
                signer_suffix: selectedColleague.Suffix,
                first_name: selectedColleague.FirstName,
                last_name: selectedColleague.LastName,
                middle_name: selectedColleague.MiddleName,
                prefix: selectedColleague.Prefix,
                suffix: selectedColleague.Suffix,
                isDocumentWitness: isDocumentWitness
              });
              segmentHelper.track(
                isDocumentWitness
                  ? segmentHelper.events.MASTER_CLIENT_DOCUMENTWITNESS_SELECTED
                  : segmentHelper.events.MASTER_CLIENT_SIGNER_SELECTED
              );
            }, 200);
          });
          if (!isDocumentWitness) {
            // If it is a signer, reset the signer state
            resetSignerState();
          }
        }, 100);
      });
    }, 100);

    // Open document witness form
    if (isDocumentWitness && openDocumentWithness) {
      setTimeout(() => {
        openDocumentWithness('edit_document_witness', {
          signer_id: signerData.signer_id,
          identificationFlow: enums.UI_FLOW_TYPE.WITNESS_ONE,
          GUID: obj.GUID,
          signer_guid: obj.GUID,
          signer_first_name: obj.signer_first_name,
          signer_last_name: obj.signer_last_name,
          signer_middle_name: obj.signer_middle_name,
          signer_prefix: obj.signer_prefix,
          signer_suffix: obj.signer_suffix,
          first_name: obj.FirstName,
          last_name: obj.LastName,
          middle_name: obj.middle_name,
          prefix: obj.prefix,
          suffix: obj.suffix,
          isDocumentWitness: true
        });
      }, 500);
    }
  };

  const handleAcknowledgeForSignerByMark = () => {
    setCurrentState('load_colleague');
    if (isSignerByMarkIndex === 'one') {
      setSignerByMark({
        ...signerByMark,
        witness_one_GUID: selectedColleague.GUID,
        witness_one_first_name: selectedColleague.FirstName,
        witness_one_last_name: selectedColleague.LastName,
        witness_one_id: idGenerator.getMarkWitnessId(),
        witnessOneIdentification: {
          signer_id: signerByMark.signer_id,
          identification_id: selectedColleague.Identifications[0].GUID,
          id_first_name: selectedColleague.Identifications[0].FirstName,
          id_middle_name: selectedColleague.Identifications[0].MiddleName,
          id_last_name: selectedColleague.Identifications[0].LastName,
          prefix: selectedColleague.Identifications[0].Prefix,
          suffix: selectedColleague.Identifications[0].Suffix,
          id_type: selectedColleague.Identifications[0].IdType,
          id_type_other: selectedColleague.Identifications[0]?.IdTypeOther,
          id_number: selectedColleague.Identifications[0].IdNumber,
          id_issued_date: selectedColleague.Identifications[0].IdIssued,
          id_expiration_date: selectedColleague.Identifications[0].IdExpiration,
          date_of_birth: selectedColleague.Identifications[0].DateOfBirth,
          id_issuing_state: selectedColleague.Identifications[0].IdIssuingState,
          id_address_1: selectedColleague.Identifications[0].Address1,
          id_address_2: selectedColleague.Identifications[0].Address2,
          id_city: selectedColleague.Identifications[0].City,
          id_state: selectedColleague.Identifications[0].State,
          id_postal_code: selectedColleague.Identifications[0].PostalCode,
          notes: selectedColleague.Identifications[0].AdditionalData,
          scan_vendor: null,
          scan_data: null,
          GUID: selectedColleague.Identifications[0].GUID,
          IsFavorite: selectedColleague.IsFavorite
        },
        witnessOneAddress: {
          address_1: selectedColleague.Address1,
          address_2: selectedColleague.Address2,
          city: selectedColleague.City,
          state: selectedColleague.State,
          postal_code: selectedColleague.PostalCode
        }
      });
    } else if (isSignerByMarkIndex === 'two') {
      setSignerByMark({
        ...signerByMark,
        witness_two_GUID: selectedColleague.GUID,
        witness_two_first_name: selectedColleague.FirstName,
        witness_two_last_name: selectedColleague.LastName,
        witness_two_id: idGenerator.getMarkWitnessId(),
        witnessTwoIdentification: {
          signer_id: signerByMark.signer_id,
          identification_id: selectedColleague.Identifications[0].GUID,
          id_first_name: selectedColleague.Identifications[0].FirstName,
          id_middle_name: selectedColleague.Identifications[0].MiddleName,
          id_last_name: selectedColleague.Identifications[0].LastName,
          prefix: selectedColleague.Identifications[0].Prefix,
          suffix: selectedColleague.Identifications[0].Suffix,
          id_type: selectedColleague.Identifications[0].IdType,
          id_type_other: selectedColleague.Identifications[0]?.IdTypeOther,
          id_number: selectedColleague.Identifications[0].IdNumber,
          id_issued_date: selectedColleague.Identifications[0].IdIssued,
          id_expiration_date: selectedColleague.Identifications[0].IdExpiration,
          date_of_birth: selectedColleague.Identifications[0].DateOfBirth,
          id_issuing_state: selectedColleague.Identifications[0].IdIssuingState,
          id_address_1: selectedColleague.Identifications[0].Address1,
          id_address_2: selectedColleague.Identifications[0].Address2,
          id_city: selectedColleague.Identifications[0].City,
          id_state: selectedColleague.Identifications[0].State,
          id_postal_code: selectedColleague.Identifications[0].PostalCode,
          notes: selectedColleague.Identifications[0].AdditionalData,
          scan_vendor: null,
          scan_data: null,
          GUID: selectedColleague.Identifications[0].GUID,
          IsFavorite: selectedColleague.IsFavorite
        },
        witnessTwoAddress: {
          address_1: selectedColleague.Address1,
          address_2: selectedColleague.Address2,
          city: selectedColleague.City,
          state: selectedColleague.State,
          postal_code: selectedColleague.PostalCode
        }
      });
    }
    segmentHelper.track(
      segmentHelper.events.MASTER_CLIENT_SIGNATUREBYMARKWITNESS_SELECTED
    );
    setOpenLegalNotice(false); //close model
    setShowColleagueModal(false); // close colleague
    setIsSignerByMarkIndex && setIsSignerByMarkIndex('');
  };

  const logAllChanges = signerData => {
    let {
      signerIdentifications,
      witnessIdentifications,
      signer_id,
      witnessChoice,
      isDocumentWitness
    } = signerData;

    let auditLogActions = [];

    //formatNameObj has checks for signer_* format of names that we use in state here.

    let fullSignerName = filters.formatName(
      signerData.signer_prefix,
      signerData.signer_first_name,
      signerData.signer_middle_name,
      signerData.signer_last_name,
      signerData.signer_suffix
    );
    logger.log('fullSignerName', fullSignerName, signerData);
    if (signerData.isEditMode) {
      //detect name change
      let foundSigner = _.find(signers, s => s.signer_id === signer_id);
      let oldSignerFullName = filters.formatNameObj(foundSigner);
      if (oldSignerFullName !== fullSignerName) {
        auditLogActions.push(
          `${
            isDocumentWitness ? 'Document Witness' : 'Signer'
          } name changed from ${oldSignerFullName} to ${fullSignerName}.`
        );
      }

      //Detect adding or removing IDs
      let oldIdentificationIds = [];
      _.each(identifications, i => {
        if (i.signer_id === signer_id && !i.witness_id) {
          oldIdentificationIds.push(i.identification_id);
        }
      });
      let newIdentificationIds = [];
      _.each(signerIdentifications, sResult => {
        if (!sResult.witness_id) {
          newIdentificationIds.push(
            _.get(sResult, 'identification.identification_id')
          );
        }
      });
      _.each(oldIdentificationIds, oid => {
        if (!_.find(newIdentificationIds, nid => oid === nid)) {
          //then this old id was removed
          auditLogActions.push(
            `${
              isDocumentWitness ? 'Document Witness' : 'Signer'
            } ${fullSignerName} ID removed.`
          );
        }
      });
      _.each(newIdentificationIds, nid => {
        if (!_.find(oldIdentificationIds, oid => oid === nid)) {
          //then this old id was removed
          auditLogActions.push(
            `${
              isDocumentWitness ? 'Document Witness' : 'Signer'
            } ${fullSignerName} ID added.`
          );
        }
      });

      //detect witness choice changes
      let oldWitnessIds = [];
      _.each(witnesses, w => {
        if (w.signer_id === signer_id) {
          oldWitnessIds.push(w.witness_id);
        }
      });
      let newWitnessIds = [];
      _.each(witnessIdentifications, wResult => {
        newWitnessIds.push(wResult.witness_id);
      });
      _.each(oldWitnessIds, owd => {
        if (!_.find(newWitnessIds, nwd => owd === nwd)) {
          //then this old id was removed
          auditLogActions.push(
            `${
              isDocumentWitness ? 'Document Witness' : 'Signer'
            } ${fullSignerName} witness removed.`
          );
        }
      });
      _.each(newWitnessIds, nwd => {
        if (!_.find(oldWitnessIds, owd => owd === nwd)) {
          //then this old id was removed
          auditLogActions.push(
            `${
              isDocumentWitness ? 'Document Witness' : 'Signer'
            } ${fullSignerName} witness added.`
          );
        }
      });
    } else {
      //new signer added, all actions are new
      auditLogActions.push(
        `New ${
          isDocumentWitness ? 'Document Witness' : 'Signer'
        } ${fullSignerName} added.`
      );
      if (signerData.witnessChoice === enums.UI_FLOW_TYPE.PERSONALLY_KNOWN) {
        //The app would currently add a new ID for them of this type, but this is
        //not present in the Identifications list
        //explicit add here
        //Comment by Kaushal to Intentionally log diff log for personally known type

        //auditLogActions.push(`Signer ${fullSignerName} ID added.`);
        auditLogActions.push(
          `Notary verified Signer ${fullSignerName} as personally known.`
        );
      } else if (
        signerData?.signerIdentifications?.length === 0 &&
        witnessIdentifications.length === 0
      ) {
        //The app would currently add a NO IDENTIFICATION type id for them, but this is
        //not present in the Identifications list
        //explicit add here
        auditLogActions.push(
          `${
            isDocumentWitness ? 'Document Witness' : 'Signer'
          } ${fullSignerName} ID added.`
        );
      } else {
        if (witnessChoice === enums.UI_FLOW_TYPE.SIGNER) {
          _.each(signerIdentifications, sResult => {
            if (!sResult.witness_id) {
              let scan_time = _.get(sResult, 'identification.scan_time');
              if (scan_time) {
                auditLogActions.push(
                  `${
                    isDocumentWitness ? 'Document Witness' : 'Signer'
                  } ${fullSignerName} ID added with ID scan performed at ${moment(
                    scan_time
                  )
                    .local()
                    .format('lll')}.`
                );

                //Add any identification related changes they may have done.
                //this is mostly special handling for the rescan/diff process.
                let auditLogChanges = _.get(
                  sResult,
                  'identification.auditLogEntries',
                  []
                );
                if (auditLogChanges.length > 0) {
                  _.each(auditLogChanges, changeText => {
                    auditLogActions.push(changeText);
                  });
                }
              } else {
                auditLogActions.push(
                  `${
                    isDocumentWitness ? 'Document Witness' : 'Signer'
                  } ${fullSignerName} ID added.`
                );
              }
            }
          });
        } else if (
          witnessChoice === enums.UI_FLOW_TYPE.WITNESS_ONE ||
          witnessChoice === enums.UI_FLOW_TYPE.WITNESS_TWO
        ) {
          _.each(witnessIdentifications, wResult => {
            let witnessFullName = filters.formatNameObj(
              _.get(wResult, 'identification', {})
            );
            auditLogActions.push(
              `New Witness ${witnessFullName} added for ${
                isDocumentWitness ? 'Document Witness' : 'Signer'
              } ${fullSignerName}.`
            );
          });
        }
      }
    }

    if (auditLogActions.length > 0) {
      _.map(auditLogActions, action => {
        dispatch(actionLogSigningAction(action));
      });
    }
  };
  const saveIdentificationUIResults = async () => {
    let { signerIdentifications, witnessIdentifications, witnessChoice } =
      signerData;
    let addDummyPromise = Promise.resolve(true);
    if (witnessChoice === enums.UI_FLOW_TYPE.PERSONALLY_KNOWN) {
      addDummyPromise = addIdentificationTypeForName(
        enums.ID_TYPES.PERSONALLY_KNOWN
      );
    } else if (
      signerIdentifications?.length === 0 &&
      witnessIdentifications?.length === 0
    ) {
      //If we're here, then we're past validation, which means we have a signer name at least.
      //Just add a "No Identification" type as a courtesy to the user.  Then can go back and edit it later.
      addDummyPromise = addIdentificationTypeForName(enums.ID_TYPES.NONE);
    }
    logger.log('addIdentificationTypeForName', signerData);
    addDummyPromise.then(() => {
      logger.log('After adding dummy identification', signerData);
      let identificationPromise = Promise.resolve(true);
      identificationPromise = addSignerIdentificationsResults();

      Promise.all([identificationPromise]).then(() => {
        addWitnessIdentificationsResults();
      });
    });
  };
  const addIdentificationTypeForName = id_type => {
    logger.log(
      'addIdentificationTypeForName adding dummy identification',
      id_type
    );
    return new Promise((resolve, reject) => {
      let {
        signer_id,
        signer_first_name,
        signer_middle_name,
        signer_last_name,
        signer_prefix,
        signer_suffix
      } = signerData;
      dispatch(
        actionAddIdentification({
          signer_id: signer_id,
          identification_id: idGenerator.getIdentificationId(),
          first_name: signer_first_name,
          middle_name: signer_middle_name,
          last_name: signer_last_name,
          prefix: signer_prefix,
          suffix: signer_suffix,
          id_type: id_type
        })
      );
      dispatch(actionMapSignerToAllDocs(signer_id));

      setTimeout(() => {
        logger.log(
          'addIdentificationTypeForName after adding dummy identification signerData',
          signerData
        );
        resolve(true);
      }, 100);
    });
  };
  const addSignerIdentificationsResults = () => {
    return new Promise((resolve, reject) => {
      let { signerIdentifications } = signerData;

      _.each(signerIdentifications, sResult => {
        logger.log('Saving Signer Identification', sResult);
        if (!sResult.witness_id) {
          //Only add if no witness
          dispatch(
            actionAddIdentification({
              signer_id: sResult.signer_id,
              identification_id: sResult.identification.identification_id,
              first_name: sResult.identification.id_first_name,
              middle_name: sResult.identification.id_middle_name,
              last_name: sResult.identification.id_last_name,
              prefix: sResult.identification.id_prefix,
              suffix: sResult.identification.id_suffix,
              id_type: sResult.identification.id_type,
              id_type_other: sResult.identification.id_type_other,
              id_number: sResult.identification.id_number,
              id_issued_date: sResult.identification.id_issued_date,
              id_expiration_date: sResult.identification.id_expiration_date,
              date_of_birth: sResult.identification.date_of_birth,
              id_issuing_state: sResult.identification.id_issuing_state,
              id_address_1: sResult.identification.id_address_1,
              id_address_2: sResult.identification.id_address_2,
              id_city: sResult.identification.id_city,
              id_state: sResult.identification.id_state,
              id_postal_code: sResult.identification.id_postal_code,
              notes: sResult.identification.notes,
              scan_vendor: sResult.identification.scan_vendor,
              scan_data: sResult.identification.scan_data
            })
          );

          dispatch(actionMapSignerToAllDocs({ signer_id: sResult.signer_id }));
        }
      });

      resolve(true);
    });
  };

  const addWitnessIdentificationsResults = () => {
    return new Promise((resolve, reject) => {
      let { witnessIdentifications } = signerData;

      _.each(witnessIdentifications, wResult => {
        dispatch(
          actionAddWitnessIdentification({
            signer_id: wResult.signer_id,
            witness_id: wResult.witness_id,
            witness_name: {
              first_name: wResult.identification.id_first_name,
              middle_name: wResult.identification.id_middle_name,
              last_name: wResult.identification.id_last_name,
              suffix: wResult.identification.id_suffix,
              prefix: wResult.identification.id_prefix
            },
            identification: wResult.identification
          })
        );
      });

      resolve(true);
    });
  };
  const onManualID = () => {
    if (isFrom === 'step4') {
      setIsManualIDSelectedForMarkWitness(true);
      const updatedSignerByMark = {
        ...signerByMark,
        [`witness_${isSignerByMarkIndex}_GUID`]: selectedColleague.GUID,
        [`witness_${isSignerByMarkIndex}_first_name`]:
          selectedColleague.FirstName,
        [`witness_${isSignerByMarkIndex}_last_name`]:
          selectedColleague.LastName,
        [`witness_${isSignerByMarkIndex}_address`]: {
          address_1: selectedColleague.Address1,
          address_2: selectedColleague.Address2,
          city: selectedColleague.City,
          state: selectedColleague.State,
          postal_code: selectedColleague.PostalCode
        }
      };
      setSignerByMark(updatedSignerByMark);
      openWitnessIdentityForm(
        signerByMark.signer_id,
        `${
          isSignerByMarkIndex === 'one'
            ? signerByMark.witness_one_id
            : signerByMark.witness_two_id
        }`
      );
    } else {
      setIsManualIDSelected(true);
      setShowIdentityForm(true);
    }
  };

  // Search Master Client
  const searchItems = useAsyncDebounce(e => {
    let keyword = e.target.value.toLowerCase().trim();
    setSearchKeyword(keyword);
    setIndexStart(0);
    loadMasterSiners(false, keyword, sortBy, isAsc);
  }, 500);

  const addPersonallyKnown = () => {
    segmentHelper.track(
      segmentHelper.events.SIGNING_ADD_PERSON_OPTION_SELECTED +
        enums.UI_FLOW_TYPE.PERSONALLY_KNOWN
    );
    const obj = {};
    obj.GUID = selectedColleague.GUID;
    obj.signer_guid = selectedColleague.GUID;
    obj.signer_first_name = selectedColleague.FirstName;
    obj.signer_id = signerData.signer_id;
    obj.signer_last_name = selectedColleague.LastName;
    obj.signer_middle_name = selectedColleague.MiddleName;
    obj.signer_prefix = selectedColleague.Prefix;
    obj.signer_suffix = selectedColleague.Suffix;
    obj.signer_first_name = selectedColleague.FirstName;

    obj.first_name = selectedColleague.FirstName;
    obj.last_name = selectedColleague.LastName;
    obj.middle_name = selectedColleague.MiddleName;
    obj.prefix = selectedColleague.Prefix;
    obj.suffix = selectedColleague.Suffix;
    obj.identificationFlow = enums.UI_FLOW_TYPE.PERSONALLY_KNOWN;
    obj.witnessChoice = enums.UI_FLOW_TYPE.PERSONALLY_KNOWN;
    obj.isDocumentWitness = isDocumentWitness;
    setSignerData(obj);
    logAllChanges(obj);

    dispatch(
      actionSetSignerName({
        signer: obj
      })
    );
    setCurrentState('load_colleague');
    setOpenLegalNotice(false); //close model
    setOpenPesonallyNotice(false); //close notice acknowlage
    setShowColleagueModal(false); // close colleague

    dispatch(
      actionAddIdentification({
        signer_id: signerData.signer_id,
        GUID: selectedColleague.GUID,
        identification_id: idGenerator.getIdentificationId(),
        first_name: selectedColleague.FirstName,
        middle_name: selectedColleague.MiddleName,
        last_name: selectedColleague.LastName,
        prefix: selectedColleague.Prefix,
        suffix: selectedColleague.Suffix,
        id_type: enums.ID_TYPES.PERSONALLY_KNOWN
      })
    );
  };

  const handleCreditableWitness = type => {
    const obj = {};
    obj.GUID = selectedColleague.GUID;
    obj.signer_first_name = selectedColleague.FirstName;
    obj.signer_id = signerData.signer_id;
    obj.signer_last_name = selectedColleague.LastName;
    obj.signer_middle_name = selectedColleague.MiddleName;
    obj.signer_prefix = selectedColleague.Prefix;
    obj.signer_suffix = selectedColleague.Suffix;
    obj.signer_first_name = selectedColleague.FirstName;

    obj.first_name = selectedColleague.FirstName;
    obj.last_name = selectedColleague.LastName;
    obj.middle_name = selectedColleague.MiddleName;
    obj.prefix = selectedColleague.Prefix;
    obj.suffix = selectedColleague.Suffix;
    obj.identificationFlow = type;
    setSignerData(obj);
    if (type === enums.UI_FLOW_TYPE.WITNESS_TWO) {
      setSignerData(signerData => ({
        ...obj,
        witnessChoice: type,
        sorted_witness_ids: _.sortBy(
          [idGenerator.getWitnessId(), idGenerator.getWitnessId()],
          w => {
            return w;
          }
        )
      }));
    } else {
      setSignerData(signerData => ({
        ...obj,
        witnessChoice: type,
        sorted_witness_ids: [idGenerator.getWitnessId()]
      }));
    }

    setIsColleagues && setIsColleagues(false);
    setCollapsed && setCollapsed(true);
    setCurrentState('load_colleague');
    setShowColleagueModal(false);
    setIsColleaguesWitness && setIsColleaguesWitness(true);

    setIsManualIDSelected(false);
    setSelectedColleague({});
  };

  // Sort Master Client
  const sortItems = (sortValue, isAsc) => {
    setSortBy(sortValue);
    setIsAsc(isAsc);
    setIndexStart(0);
    loadMasterSiners(false, searchKeyword, sortValue, isAsc);
  };

  return (
    <>
      <Offcanvas
        id="offcanvas-identity-form"
        show={showColleagueModal}
        backdrop="static"
        onHide={() => {
          resetLoadCollegues();
        }}
        placement="end"
        className="jurat-wide-offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Master Client List</Offcanvas.Title>
        </Offcanvas.Header>
        <hr className="my-0" />
        <Offcanvas.Body>
          {currentState == 'load_colleague' && (
            <>
              <Form.Control
                type="text"
                placeholder="Search Client List"
                name="search"
                className="my-2"
                onChange={e => searchItems(e)}
              />
              <Form className="mb-2 d-flex align-items-center">
                <Col xs="auto">
                  <small>Sort by:</small>
                </Col>
                <Col xs="auto">
                  <InputGroup>
                    <Form.Select
                      className="pe-5"
                      defaultValue="Created"
                      onChange={({ target }) => sortItems(target.value, isAsc)}
                    >
                      <option value="Created">Created</option>
                      <option value="IsFavorite">Colleagues</option>
                      <option value="FirstName">Client Name</option>
                      {/* <option value="JournalEntries">Journal Entries</option>
                      <option value="PotentialDuplicates">
                        Potential Duplicates
                      </option> */}
                      {/* <option value="lastSeen">Last Seen</option> */}
                    </Form.Select>
                    <InputGroup.Text
                      as={Button}
                      variant="link"
                      className="border border-300 text-700"
                      onClick={() => sortItems(sortBy, !isAsc)}
                    >
                      <FontAwesomeIcon
                        icon={isAsc ? 'sort-amount-up' : 'sort-amount-down'}
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              </Form>
            </>
          )}
          {currentState == 'load_colleague' && (
            <>
              <ListGroup>
                {masterSignerList?.map(item => {
                  // Filter out identifications with 'Personally Known' or undefined/null IdType
                  const filteredIdentifications =
                    item.Identifications?.filter(
                      id =>
                        id.IdType !== 'No Identification' &&
                        id.IdType !== 'Personally Known'
                    ) || [];
                  return (
                    <ListGroup.Item
                      className="cursor-pointer"
                      key={item.GUID}
                      onClick={() => {
                        const data = handleSelectColleague(item);
                        if (data && (isDocumentWitness || isFrom === 'step4')) {
                          setOpenSavedIDOptions(!openSavedIDOptions);
                          setCurrentState('load_identification');
                        }
                      }}
                    >
                      <Flex justifyContent="between" alignItems="center">
                        <div>
                          <h6>
                            {item.Prefix && item.Prefix + ' '}
                            {item.FirstName && item.FirstName + ' '}
                            {item.MiddleName && item.MiddleName + ' '}
                            {item.LastName && item.LastName + ' '}
                            {item.Suffix}
                          </h6>
                          <SoftBadge pill bg="primary" className="me-2">
                            {filteredIdentifications?.length} Identification
                          </SoftBadge>
                        </div>
                        <div className="d-flex gap-2">
                          <FontAwesomeIcon
                            className={item.IsFavorite ? 'text-primary' : ''}
                            icon={item.IsFavorite ? faStar : faStarRegular}
                          />
                          <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                      </Flex>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
              {!hasMoreData && (
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    variant="primary"
                    className="w-auto"
                    disabled={loading}
                    onClick={() =>
                      loadMasterSiners(true, searchKeyword, sortBy, isAsc)
                    }
                  >
                    {loading ? (
                      <>
                        <Spinner size="sm" />
                        &nbsp;Loading
                      </>
                    ) : (
                      'Load more clients'
                    )}
                  </Button>
                </div>
              )}
            </>
          )}
          {currentState == 'load_options' && (
            <>
              <div
                className="d-flex align-items-center cursor-pointer "
                onClick={() => {
                  setCurrentState('load_colleague');
                }}
              >
                <FontAwesomeIcon
                  icon="chevron-left"
                  transform="shrink-4 down-1"
                  className="mx-2"
                />
                <h5 className="m-0 p-0">Identification Options</h5>
              </div>
              <div className="my-2">
                how would you like to identify this signer?
              </div>
              <ListGroup>
                <ListGroup.Item
                  className="cursor-pointer text-center hover-primary"
                  onClick={() => {
                    setOpenSavedIDOptions(!openSavedIDOptions);
                    setCurrentState('load_identification');
                  }}
                >
                  Identification
                </ListGroup.Item>
                <ListGroup.Item
                  className="cursor-pointer text-center hover-primary"
                  onClick={
                    () => {
                      setOpenPesonallyNotice(!openPesonallyNotice);
                    }
                    // addPersonallyKnown
                  }
                >
                  Personally Known
                </ListGroup.Item>
                <ListGroup.Item
                  className="cursor-pointer text-center hover-primary"
                  onClick={() => {
                    setCurrentState('load_witness_options');
                  }}
                >
                  Credible Witness
                </ListGroup.Item>
              </ListGroup>
            </>
          )}
          {currentState == 'load_identification' && (
            <>
              <div
                className="d-flex align-items-center cursor-pointer "
                onClick={() => {
                  if (isDocumentWitness || isFrom === 'step4') {
                    setCurrentState('load_colleague');
                  } else {
                    setCurrentState('load_options');
                  }
                }}
              >
                <FontAwesomeIcon
                  icon="chevron-left"
                  transform="shrink-4 down-1"
                  className="mx-2"
                />
                <h5 className="m-0 p-0">Saved ID Options</h5>
              </div>
              <div className="my-2">
                Selecting an ID type will automatically insert the signer's ID
                information if they have one saved. If not, you can enter & save
                one.
              </div>
              <h5 className="mb-3 mt-3">Saved Identifications</h5>
              <ListGroup>
                {selectedColleague?.Identifications &&
                  selectedColleague?.Identifications?.map(ID => {
                    return (
                      <>
                        {ID?.IdType !== 'No Identification' &&
                          ID?.IdType !== 'Personally Known' && (
                            <ListGroup.Item
                              key={ID?.GUID}
                              className="cursor-pointer hover-primary"
                              onClick={() => {
                                setSelectedID(ID);
                                setOpenLegalNotice(!openLegalNotice);
                              }}
                            >
                              {/* {ID?.IdType} */}
                              {draftEntryUiHelper.getIdentificationViewCard(
                                {
                                  ...ID,
                                  id_type: ID.IdType,
                                  prefix: ID.Prefix,
                                  suffix: ID.suffix,
                                  first_name: ID.FirstName,
                                  middle_name: ID.MiddleName,
                                  last_name: ID.LastName,
                                  id_number: ID.IdNumber,
                                  date_of_birth: ID.DateOfBirth,
                                  id_expiration_date: ID.IdExpiration,
                                  id_issued_date: ID.IdIssued,
                                  id_address_1: ID.Address1,
                                  id_address_2: ID.Address2,
                                  id_city: ID.City,
                                  id_state: ID.State,
                                  id_postal_code: ID.PostalCode,
                                  notes: ID.AdditionalData
                                },
                                false, //Not required removeMethod here
                                12, // pass col as 12 so card fits in whole row
                                false // Not required editMethod here
                              )}
                            </ListGroup.Item>
                          )}
                      </>
                    );
                  })}
                <ListGroup.Item
                  className="cursor-pointer text-center hover-primary"
                  onClick={onManualID}
                >
                  Manually Enter ID
                </ListGroup.Item>
              </ListGroup>
            </>
          )}
          {currentState == 'load_witness_options' && (
            <>
              <div
                className="d-flex align-items-center cursor-pointer "
                onClick={() => setCurrentState('load_options')}
              >
                <FontAwesomeIcon
                  icon="chevron-left"
                  transform="shrink-4 down-1"
                  className="mx-2"
                />
                <h5 className="m-0 p-0">Credible Witnesses</h5>
              </div>
              <div className="my-2">
                How many credible witnesses are you using to identify this
                signer?
              </div>
              <ListGroup>
                <ListGroup.Item
                  key={1}
                  className="cursor-pointer text-center hover-primary"
                  onClick={() =>
                    handleCreditableWitness(enums.UI_FLOW_TYPE.WITNESS_ONE)
                  }
                >
                  One Credible Witness
                </ListGroup.Item>
                <ListGroup.Item
                  key={2}
                  className="cursor-pointer text-center hover-primary"
                  onClick={() =>
                    handleCreditableWitness(enums.UI_FLOW_TYPE.WITNESS_TWO)
                  }
                >
                  Two Credible Witness
                </ListGroup.Item>
              </ListGroup>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
      {/* Legal Notice */}
      <Modal
        show={openLegalNotice}
        onHide={() => setOpenLegalNotice(!openLegalNotice)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Legal Notice
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            You may still be required by law to physically see the signer's ID.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button
              variant="primary"
              className="mx-1"
              onClick={() =>
                isFrom === 'step4'
                  ? handleAcknowledgeForSignerByMark()
                  : handleAcknowledge('load_identification')
              }
            >
              Acknowledge
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Personally known model */}
      <Modal
        show={openPesonallyNotice}
        onHide={() => setOpenPesonallyNotice(!openPesonallyNotice)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Personally Known Signer Selected
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="my-2">
            This method requires the notary to personally know the signer.
            Please check your state notary laws for further guidance.
            <IconAlert variant={'warning'} className={'my-2'}>
              <p className="mb-0">
                By verifying that this signer is personally known to the notary,
                you as the notary are solely responsible for the implications of
                identifying a signer with this method.
              </p>
            </IconAlert>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-end">
            <Button
              variant="primary"
              className="mx-1"
              onClick={() => addPersonallyKnown()}
            >
              Acknowledge
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default LoadColleague;
